export default "__VITE_ASSET__CHSz$1zR__"